//https://github.com/capacitor-community/http
import { Http } from '@capacitor-community/http';
import { CustomCookieManager } from '../CustomCookieManager';
import { ClientBase } from '../HttpClientSelector';

class CapacitorCommunityHttp implements ClientBase {
  private static _instance: CapacitorCommunityHttp;

  private constructor() {}

  public static Instance(): CapacitorCommunityHttp {
    return this._instance || (this._instance = new this());
  }

  public Post = <TOut>(options: {
    data: any;
    contentType: string;
    baseUrl?: string;
    serviceUrl?: string;
    methodUrl?: string;
  }): Promise<any> => {
    const _url = (options.baseUrl || '') + (options.serviceUrl || '') + (options.methodUrl || '');
    return Http.request({
      method: 'POST',
      url: _url,
      headers: {
        'Content-Type': options.contentType,
        Cookie: CustomCookieManager.GiveCookies(),
        withCredentials: 'false',
      },
      data: options.data,
    });
  };

  public Get = <TOut>(options: {
    baseUrl?: string;
    serviceUrl?: string;
    methodUrl?: string;
  }): Promise<any> => {
    const _url = (options.baseUrl || '') + (options.serviceUrl || '') + (options.methodUrl || '');
    return Http.request({
      method: 'GET',
      url: _url,
      headers: {
        Cookie: CustomCookieManager.GiveCookies(),
        withCredentials: 'false',
      },
    });
  };
}

const CapacitorCommunityHttpInstance = CapacitorCommunityHttp.Instance();

export default CapacitorCommunityHttpInstance;
